import strFunc from "@/lib/lyg/string";
import PrintOnePageArea from "../print_one_page";

function PrintListArea(props: any) {
  let myProps = {
    todo_info: {},
    print_options: {},
    ...props
  };
  let todo_info = myProps.todo_info;
  let print_options = myProps.print_options;
  let tmp_cg_word_arr = [];
  let able_word_arr = [];
  let start_word_idx = strFunc.uncomma_int(todo_info["a_success_amount_start"]);
  let end_word_length = strFunc.uncomma_int(todo_info["a_success_amount"]);

  if (todo_info && todo_info.mtextbook_info
    && todo_info.mtextbook_info.study_arr
    && todo_info.mtextbook_info.study_arr.length > 0
    && todo_info.mtextbook_info.study_arr[0].cg_word_arr
  ) {
    tmp_cg_word_arr = todo_info.mtextbook_info.study_arr[0].cg_word_arr;
  }
  if (todo_info && todo_info.word_inside_info
    && todo_info.word_inside_info.cg_word_arr
    && todo_info.word_inside_info.cg_word_arr.length > 0
  ) {
    tmp_cg_word_arr = todo_info.word_inside_info.cg_word_arr;
  }

  if (tmp_cg_word_arr.length > 0) {
    for (let i = start_word_idx; i < start_word_idx + end_word_length; i++) {
      if (tmp_cg_word_arr[i]) {
        able_word_arr.push(tmp_cg_word_arr[i]);
      }
    }
  }

  let total_page_num = 0;
  let repeat_cnt = print_options.repeat_cnt || 10;
  let row_cnt = 0;
  let col_cnt = 0;
  let one_page_word_cnt = 0;
  //row 10, col 5
  if (print_options.print_templete === "box") {
    row_cnt = print_options.box_opt.row;
    col_cnt = print_options.box_opt.col;
  } else if (print_options.print_templete === "line") {
    row_cnt = print_options.line_opt.row;
    col_cnt = print_options.box_opt.col;
  }
  let word_box_cnt = able_word_arr.length * repeat_cnt;
  let page_word_max_cnt = row_cnt * col_cnt;
  if (word_box_cnt > 0 && page_word_max_cnt > 0) {
    total_page_num = Math.ceil(word_box_cnt / page_word_max_cnt);
  }
  one_page_word_cnt=page_word_max_cnt/repeat_cnt;
  let word_page_arr: any = [];
  for (let i = 0; i < total_page_num; i++) {
    let row_word_arr: any[] = [];

    let start_idx = i * one_page_word_cnt;
    let end_idx = start_idx + one_page_word_cnt;
    
    for (let word_i = 0; word_i < able_word_arr.length; word_i++) {
      if (word_i>=start_idx && word_i < end_idx) {
        row_word_arr.push(able_word_arr[word_i]);
      }
    }
    
    let word_page_row = {
      page_num: i,
      word_arr: row_word_arr
    };
    word_page_arr.push(word_page_row);
  }

  return (
    <>
      {word_page_arr.map((page_data: any, idx: number) => {
        return (
          <PrintOnePageArea
            key={idx}
            todo_info={todo_info}
            print_options={print_options}
            total_page_num={total_page_num}
            now_page_num={page_data.page_num}
            word_arr={page_data.word_arr}
            row_cnt={row_cnt}
            col_cnt={col_cnt}
          ></PrintOnePageArea>
        );
      })}
    </>
  );
};
export default PrintListArea;